import { render, staticRenderFns } from "./employeeCardDialog.vue?vue&type=template&id=b990e398"
import script from "./employeeCardDialog.vue?vue&type=script&lang=ts"
export * from "./employeeCardDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports